import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const OctoberSehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={10} title="October Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default OctoberSehriIftaar;
